import React, { useEffect } from "react";
import AuthLayout from "../../components/auth/AuthLayout";
import PageTitle from "../../components/auth/PageTitle";
import RegisterForm from "../../components/auth/RegisterForm";
import { Link, useNavigate } from "react-router-dom";
import { useGetDictionary } from "../../hooks/useGetDictionary";
import { DictionaryType } from "../../types";

const RegisterScreen = () => {
  const { Auth }: DictionaryType = useGetDictionary();
  const navigate = useNavigate()
useEffect(()=>{
  const token = localStorage.getItem('token')
  if(token){
navigate('/')
  }
  
  
})
  return (
    <AuthLayout padding="px-0" height="h-fit">
      <div className=" mt-4 flex flex-col gap-6">
        <div className="flex flex-col gap-5 text-center">
          <PageTitle title={Auth?.regiter_page.register_title} />

          <p className="text-lg font-normal leading-[22.68px] text-[#1E1850] mt-2">
            {Auth?.regiter_page.register_subtitle}{" "}
            <span className="text-red-500 font-bold">
              <Link to="/auth/login">{Auth?.login}</Link>{" "}
            </span>
          </p>
        </div>

        <RegisterForm />
      </div>
    </AuthLayout>
  );
};

export default RegisterScreen;
